<template>
	<div class="worklist-page p-10">
		<!-- SUBHEADER -->
		<h1>{{ $t('worklist.title') }}</h1>
		<!-- END SUBHEADER -->
		<el-tabs v-model="worklistExecutionType">
			<el-tab-pane :label="$t('worklist.manual')" name="MANUAL">
			</el-tab-pane>
			<el-tab-pane :label="$t('worklist.automated')" name="AUTOMATED">
			</el-tab-pane>
			<el-tab-pane :label="$t('worklist.all')" name="ALL">
			</el-tab-pane>
		</el-tabs>
		<el-card class="worklist-card">
			<ActionTable />
		</el-card>
	</div>
</template>

<script>
import ActionTable from '@/components/_ActionTable/WorklistActionTable.vue';
export default {
	components: {
		ActionTable
	},
	computed: {
		worklistExecutionType: {
			get() {
				const stored = this.$store.state.worklist.worklistExecutionType;
				if (stored === null) {
					return 'ALL';
				}
				return stored || 'MANUAL';
			},
			set(val) {
				if (val === 'ALL') {
					this.$store.commit('worklist/SET_WORKLIST_EXECUTION_TYPE', null);
				} else {
					this.$store.commit('worklist/SET_WORKLIST_EXECUTION_TYPE', val);
				}
			}
		}
	},
	created() {
		this.$store.commit('worklist/SET_WORKLIST_GROUPVARS', {
			showManualActions: true
		});
	}
};
</script>

<style lang="scss">
.worklist-page {
	height: calc(100vh - 50px);
	display: flex;
	flex-direction: column;
}

.hasTagsView .worklist-page {
	height: calc(100vh - 84px);
}

.worklist-card {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	.el-card__body {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
		padding: 10px;
	}

	.el-card__body > * {
		flex: 1;
		min-height: 0;
	}
}
</style>
